export default {
  defaultPrimaryColor: 'rgba(0, 0, 0, 0.4)',
  darkPrimaryColor: 'rgba(0, 0, 0, 0.6)',
  almostBlack: 'rgba(0, 0, 0, 0.9)',
  colorBlack: '#000000', // &0
  colorDarkBlue: '#0000AA', // &1
  colorDarkGreen: '#00AA00', // &2
  colorDarkAqua: '#00AAAA', // &3
  colorDarkRed: '#AA0000', // &4
  colorDarkPurple: '#AA00AA', // &5
  colorGold: '#FFAA00', // &6
  colorGray: '#AAAAAA', // &7
  colorDarkGray: '#555555', // &8
  colorBlue: '#5555FF', // &9
  colorGreen: '#55FF55', // &a
  colorAqua: '#55FFFF', // &b
  colorRed: '#FF5555', // &c
  colorLightPurple: '#FF55FF', // &d
  colorYellow: '#FFFF55', // &e
  colorWhite: '#FFFFFF', // &f
  shadowBlack: '#000000',
  shadowDarkBlue: '#00002A',
  shadowDarkGreen: '#002A00',
  shadowDarkAqua: '#002A2A',
  shadowDarkRed: '#2A0000',
  shadowDarkPurple: '#2A002A',
  shadowGold: '#2A2A00',
  shadowGray: '#2A2A2A',
  shadowDarkGray: '#151515',
  shadowBlue: '#15153F',
  shadowGreen: '#153F15',
  shadowAqua: '#153F3F',
  shadowRed: '#3F1515',
  shadowLightPurple: '#3F153F',
  shadowYellow: '#3F3F15',
  shadowWhite: '#3F3F3F',
  colorSuccess: '#66BB6A',
  colorDanger: '#ff4c4c',
  colorMuted: '#727272',
  colorYelor: '#FFAB40',
  colorGolden: '#e5c100',
  colorBlueGray: '#7c99a8',
  green: '#66BB6A',
  blue: '#6BF',
  golden: '#e5c100',
  yelor: '#FFAB40',
  red: '#ff4c4c',
  lightGray: 'rgb(179, 179, 179)',
  colorBlackMuted: 'rgba(0, 0, 0, .75)',
  colorBlueMuted: 'rgba(102, 187, 255, 0.3)',
  colorYelorMuted: 'rgba(255, 171, 64, 0.3)',
  colorMutedLight: 'rgb(179, 179, 179)',
  colorMutedGreen: '#325233',
  colorMutedRed: '#523332',
  colorRanked: 'rgba(241, 170, 64, 0.81)',
  primaryLinkColor: '#6BF',
  textColorPrimary: '#F5F5F5',
  primaryTextColor: '#F5F5F5',
  textColorSecondary: '#212020',
  secondaryTextColor: '#212020',
  primarySurfaceColor: 'rgb(46, 47, 64)',
  secondarySurfaceColor: 'rgb(39, 39, 58)',
  tableHeaderSurfaceColor: 'rgba(0, 0, 0, .3)',
  tableRowOddSurfaceColor: 'rgba(255, 255, 255, .019)',
  tableRowEvenSurfaceColor: 'rgba(0, 0, 0, .019)',
  sliderTicksColor: '#757575',
  sliderTicksColorActive: '#337AB7',
  dividerColor: 'rgb(52, 50, 50)',
  fontFamily: `
      -apple-system, BlinkMacSystemFont,
      "Segoe UI",
      Roboto, "Droid Sans",
      Ubuntu, Cantarell,
      "Fira Sans",
      Helvetica, Arial, sans-serif`,
  fontWeightLight: '300',
  fontWeightNormal: '400',
  fontWeightMedium: '500',
  fontSizeCommon: '16px',
  fontSizeMedium: '14px',
  fontSizeSmall: '12px',
  fontSizeTiny: '10px',
  navDrawerWidth: '256px',
  normalTransition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  linearTransition: 'all 300ms linear',
  wrapTablet: '1024px',
  wrapMobile: '680px',
  appWidth: 1200,
};
